export class Representative {
    name = ''
    taxDocument = ''
    gender = ''
    birthDate = ''
}
